// extracted by mini-css-extract-plugin
export var parcelRow = "_rx-0";